import { render, staticRenderFns } from "./FormInputList.vue?vue&type=template&id=684e8ba6&scoped=true"
import script from "./FormInputList.vue?vue&type=script&lang=js"
export * from "./FormInputList.vue?vue&type=script&lang=js"
import style0 from "./FormInputList.vue?vue&type=style&index=0&id=684e8ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e8ba6",
  null
  
)

export default component.exports